import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { App } from '@df/core/app';
import { Basket } from '@df/session/api/basket/basket';
import { BasketService } from '@df/session/api/basket/basket.service';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import find from 'lodash-es/find';
import { Subscription } from 'rxjs';
import { NBasketTotalModal } from './basket-total-modal.interface';
@Injectable({
    providedIn: 'root'
})
export class BasketTotalModalInitiatorService extends AbstractDfModalInitiatorService implements OnDestroy {
    private addToBasketSuccessSubscription: Subscription;
    private changeQtySuccessSubscription: Subscription;
    private routeChangeSubscription: Subscription;
    constructor(
        dfModalService: DfModalService,
        app: App,
        private iCmsBlockResource: ICmsBlockResource,
        private basket: Basket,
        private basketService: BasketService
    ) {
        super(dfModalService, app);
    }
    ngOnDestroy(): void {
        this.routeChangeSubscription?.unsubscribe();
        this.addToBasketSuccessSubscription?.unsubscribe();
        this.changeQtySuccessSubscription?.unsubscribe();
    }
    listen(cb: () => void): Promise<void> {
        return new Promise(resolve => {
            this.iCmsBlockResource
                .retrieve({ bareUrl: NBasketTotalModal.BLOCK_ID }, undefined)
                .then(block => {
                    if (block) {
                        this.routeChangeSubscription?.unsubscribe();
                        this.routeChangeSubscription = this.app.meta.routerEvents.subscribe(event => {
                            if (event instanceof NavigationEnd && this.canShow(block)) {
                                cb();
                            }
                        });
                        this.addToBasketSuccessSubscription?.unsubscribe();
                        this.addToBasketSuccessSubscription = this.basketService.subscribeToAddToBasketSuccess(() => {
                            if (this.canShow(block)) {
                                cb();
                            }
                        });
                        this.changeQtySuccessSubscription?.unsubscribe();
                        this.changeQtySuccessSubscription = this.basketService.subscribeToChangeQtySuccess(() => {
                            if (this.canShow(block)) {
                                cb();
                            }
                        });
                        if (this.canShow(block)) {
                            cb();
                        }
                        resolve();
                    } else {
                        resolve();
                    }
                })
                .catch(() => resolve());
        });
    }
    get currency() {
        return this.app.data.currency.base;
    }
    private canShow(block: NBasketTotalModal.IBlock): boolean {
        const data = find(block.data.content.goals, goal => goal.currency === this.currency);
        const subtotal = this.basket?.totals?.subtotal;
        if (data && subtotal) {
            return subtotal >= data.goal;
        }
        return false;
    }
}
